import React from 'react';
import styled from 'styled-components';
import Typography from '../../common/typography/Typography';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 20px; /* Add spacing between container and button */
`;

const Button = styled.button`
  margin: auto;
  height: 52px;
  padding: 16px 24px;
  border-radius: 8px;
  opacity: 0px;
  background-color: #5b63f6;
  color: white;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 5px;
  font-family: 'Gilroy', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;

  &:hover {
    background-color: #777;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @media (min-width: 600px) {
    padding-left: 56px;
    padding-right: 56px;
  }
`;

const ImageWrapper = styled.div`
  flex: 1;
  max-width: 50%;
  padding: 10px;

  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0;
  }
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 50%;
  padding: 10px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
  padding: 5px 15px;

  @media (max-width: 480px) {
    margin-bottom: 15px;
    padding: 5px 10px;
  }
`;

const IconWrapper = styled.img`
  padding:4px;
  width: 90px;
  height: 90px;
  @media (max-width: 768px) {
    padding:4px;
    width: 50px;
    height: 50px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  margin: 0 0 5px;
`;
const organizersData = [
  {
    title: '1. Increased Participant Satisfaction',
    description:
      "Including offline activities enhances the overall event experience, leading to higher satisfaction levels among participants. When attendees enjoy a balanced mix of interactive and offline engagements, they are more likely to give positive feedback, boosting your event’s reputation and encouraging future participation.",
    iconSrc: './static/organizers_icon.svg',
  },
  {
    title: '2. Create Unique Selling Points',
    description:
      "Organizing offline activities gives your event a distinct competitive advantage. It sets your event apart from others by offering diverse, memorable experiences that participants can't easily find elsewhere. This uniqueness can become a major selling point, attracting more attendees and sponsors.",
    iconSrc: './static/organizers_icon.svg',
  },
  {
    title: '3. Higher Engagement and Interaction',
    description:
      "Offline activities promote deeper interaction among participants. Whether it’s through team-building exercises, workshops, or social games, these activities encourage meaningful connections between attendees, fostering networking opportunities and strengthening community engagement.",
    iconSrc: './static/organizers_icon.svg',
  },
  {
    title: '4. Attract Sponsors and Partners',
    description:
      "Offline activities offer more opportunities for sponsors to get involved, whether through branded games, activities, or event spaces. By providing additional platforms for brand visibility and interaction, you can increase sponsorship appeal, bringing in more funding and partnerships for future events.",
    iconSrc: './static/organizers_icon.svg',
  },
  {
    title: '5. Promote Health and Well-being',
    description:
      "Demonstrating a commitment to participant well-being by integrating offline activities helps position your event as forward-thinking and socially responsible. Encouraging a balance between screen time and real-world activities supports attendees' mental and physical health, which is a growing priority for many participants and companies.",
    iconSrc: './static/organizers_icon.svg',
  },
];

const Organizers = () => (
  <>
    <Container>
      <ImageWrapper>
        <img src="./static/organizers.svg" alt="organizers" />
      </ImageWrapper>
      <ListWrapper>
        {organizersData.map((organizer, index) => (
          <ListItem key={index}>
            <IconWrapper src={organizer.iconSrc} alt={`organizers_icon_${index}`} />
            <TextWrapper>
              <Title>
                <Typography size="30px" weight="700px">
                  {organizer.title}
                </Typography>
              </Title>
              <Typography size="20px" weight="500px" color="#6F6D7B">
                {organizer.description}
              </Typography>
            </TextWrapper>
          </ListItem>
        ))}
      </ListWrapper>
    </Container>
    <ButtonWrapper>
      <Button>Create Your Event</Button>
    </ButtonWrapper>
  </>
);

export default Organizers;
